<template>
  <div class="add_new_student_dialog">
    <el-dialog
      :title="title"
      :visible.sync="openDialog"
      width="1000px"
      class="dialog_title"
      @close="closeDialog"
    >
      <div class="open-header">账号信息</div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        size="small"
        label-width="106px"
      >
        <el-form-item label="上传头像：" class="avatar_item">
          <dc-upload
            v-if="isOk"
            class="avatar-uploader"
            ref="upload"
            :dcAutoUpload="true"
            dcdom="resourcestype"
            :dcConfig="dcConfig"
            @dc-success="dcSuccess"
            @dc-progress="dcProgressTrue = false"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </dc-upload>
        </el-form-item>

        <el-col :span="24" class="pb20">
          <el-row>
            <el-col :span="8">
              <el-form-item label="用户名：" prop="username">
                <el-input
                  v-model="form.username"
                  placeholder="请输入用户名"
                  clearable
                  :style="{ width: '100%' }"
                  :disabled="true"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 编辑不显示密码 -->
            <el-col :span="8" v-if="!updateId">
              <el-form-item label="密码：" prop="password">
                <el-input
                  v-model="form.password"
                  placeholder="请输入密码"
                  clearable
                  show-password
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="!updateId">
              <el-form-item label="确认密码：" prop="repassword">
                <el-input
                  v-model="form.repassword"
                  placeholder="确认密码："
                  clearable
                  show-password
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <div
          style="
            font-size: 18px;
            margin-bottom: 20px;
            margin-left: 15px;
            color: #303133;
          "
        >
          个人信息
        </div>

        <el-col :span="24">
          <el-row>
            <el-col :span="8">
              <el-form-item label="真实姓名：" prop="truename">
                <el-input
                  v-model="form.truename"
                  placeholder="请输入真实姓名"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="身份证：" prop="idnum">
                <el-input
                  v-model="form.idnum"
                  placeholder="请输入身份证"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学历：" prop="education">
                <el-select
                  v-model="form.education"
                  placeholder="请选择学历"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option
                    v-for="(item, index) in educationOptions"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别：" prop="sexy">
                <el-radio-group v-model="form.sexy" size="medium">
                  <el-radio
                    v-for="(item, index) in sexyOptions"
                    :key="index"
                    :label="item.value"
                    >{{ item.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机：" prop="tel">
                <el-input
                  v-model="form.tel"
                  placeholder="请输入手机"
                  clearable
                  :style="{ width: '100%' }"
                  @input="telChange"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="24">
              <el-form-item label="联系地址：" prop="address">
                <el-input v-model="form.address" placeholder="请输入" />
              </el-form-item>
            </el-col> -->

            <el-col :span="8">
              <el-form-item label="Email：" prop="email">
                <el-input
                  v-model="form.email"
                  placeholder="请输入Email"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="QQ：" prop="qq">
                <el-input
                  v-model="form.qq"
                  placeholder="请输入QQ"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="所属地区：" class="train">
                <!-- 星 -->
                <span class="star">*</span>
                <!-- 省 -->
                <el-form-item prop="province_id">
                  <el-select
                    v-model="form.province_id"
                    placeholder="请选择省份"
                    @change="getCityList"
                    clearable
                  >
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in provinceListArr"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- 市 -->
                <el-form-item prop="city_id">
                  <el-select
                    v-model="form.city_id"
                    placeholder="请选择城市"
                    @change="getareaList"
                  >
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in cityListArr"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- 区 -->
                <el-form-item prop="area_id">
                  <el-select
                    v-model="form.area_id"
                    placeholder="请选择地区"
                    @change="changeArea"
                  >
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in areaListArr"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- 联系地址 -->
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item class="address" prop="address" label="详情地址：">
                <el-input
                  v-model="form.address"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  :style="{ width: '100%' }"
                  placeholder="请输入详情地址"
                  @blur="inputBlurFn"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24" class="pb20">
          <el-form-item label="个人简介：" prop="description" class="desc">
            <el-input
              v-model="form.description"
              type="textarea"
              placeholder="请输入个人简介"
              :autosize="{ minRows: 2, maxRows: 4 }"
              :style="{ width: '100%' }"
            ></el-input>
          </el-form-item>
        </el-col>

        <div
          style="
            font-size: 18px;
            margin-bottom: 20px;
            margin-left: 15px;
            color: #303133;
          "
        >
          单位和学科信息
        </div>

        <el-col :span="24">
          <el-row>
            <el-col :span="8">
              <el-form-item label="单位：" prop="unit">
                <span
                  v-if="!unitName"
                  class="c-main pointer"
                  @click="onSelectUnit"
                  >选择单位</span
                >
                <div v-else>
                  <span class="mr10">{{ unitName }}</span>
                  <span class="c-main pointer" @click="onSelectUnit">修改</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职务：" prop="job">
                <el-input
                  v-model="form.job"
                  placeholder="请输入职务"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="职称：" prop="title">
                <el-select
                  v-model="form.title"
                  placeholder="请选择职称"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option
                    v-for="(item, index) in titleOptions"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学段：" prop="level">
                <el-select
                  v-model="form.level"
                  placeholder="请选择学段"
                  clearable
                  :style="{ width: '100%' }"
                  @change="handleCourseOptions"
                >
                  <el-option
                    v-for="(item, index) in levelOptions"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学科：" prop="subject">
                <!-- $forceUpdate()方法，该方法作用是迫使Vue实例重新渲染。 -->
                <el-select
                  v-model="form.subject"
                  placeholder="请选择学科"
                  clearable
                  @change="$forceUpdate()"
                >
                  <el-option
                    v-for="(item, index) in courseOptions"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="24">
          <el-form-item label="行政管理员：" prop="is_admin">
            <el-radio-group v-model="form.is_admin" size="medium">
              <el-radio
                v-for="(item, index) in is_adminOptions"
                :key="index"
                :label="item.value"
                >{{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" class="pb10">
          <el-form-item label="班主任：" prop="is_teacher">
            <el-radio-group v-model="form.is_teacher" size="medium">
              <el-radio
                v-for="(item, index) in is_teacherOptions"
                :key="index"
                :label="item.value"
                >{{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <div class="open-header">班级报名信息</div>

        <el-col :span="24">
          <el-row>
            <el-col :span="8">
              <el-form-item label="教龄：" prop="teacher_age">
                <el-input
                  v-model="form.teacher_age"
                  placeholder="请输入教龄"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="微信：" prop="weixin">
                <el-input
                  v-model="form.weixin"
                  placeholder="请输入微信"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注：" prop="remark">
                <el-input
                  v-model="form.remark"
                  placeholder="请输入备注"
                  clearable
                  :style="{ width: '100%' }"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-form>

      <div slot="footer" class="dialog-footer pt50">
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
        <el-button @click="cancel" size="small">取 消</el-button>
      </div>
      <!-- 选择单位 -->
    </el-dialog>
    <!-- 单位列表dialog -->
    <MyDialog
      ref="unitRef"
      @onClose="onClose"
      widthVal="60%"
      title="查看单位列表"
    >
      <div>
        <MySearch
          :showSelect1="0"
          :show2="0"
          :show3="0"
          :showLabel1="10"
          :triggerPhName="10"
          @changeVal="changeVal"
          @requestCommonFn="onSearch"
        ></MySearch>
        <CommonTable
          :tableData="tableData"
          @currentChange="handleCurrentChange"
          @sizeChange="handleSizeChange"
          :total="total"
          :page="unitForm.page"
          :limit="unitForm.limit"
        >
          <el-table-column label="选择" prop="title" align="center" width="100">
            <template slot-scope="{ row }">
              <el-radio
                v-model="row.radio"
                :label="1"
                @change="onRadioChange(row)"
                >{{ "" }}</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column
            label="单位名称"
            prop="name"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="单位类型" prop="type_text" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="所属地区"
            prop="area_name"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
        </CommonTable>
        <div class="tar pt20">
          <el-button type="primary" @click="onCommitUnit" size="small"
            >确定</el-button
          >
          <el-button @click="onCancelUnit" size="small">取消</el-button>
        </div>
      </div>
    </MyDialog>
  </div>
</template>

<script>
import { GetKey_Url, UPloadFileApi } from "@/api/student";
import {
  CityListApi,
  AreaListApi,
  ProvinceListApi,
  GetDataList,
  AddNewStudent,
  ClassInfoApi,
  UpdateNewStudent,
  StudentEditorInfo,
  GetOrganizetionList,
} from "@/api/tearcher";
import { isCheck } from "@/util/constOptions";
export default {
  data() {
    // 确认密码
    var againValidatePass = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    // 验证单位
    var validateUnit = (rule, value, callback) => {
      if (!this.form.unit) {
        callback(new Error("请选择单位"));
      } else {
        callback();
      }
    };
    return {
      openDialog: false,
      isOk: false,
      form: {
        subject: "",
        is_admin: 0,
        is_teacher: 0,
      },
      educationOptions: [], //获取学历列表
      provinceListArr: [], // 获取省列表
      cityListArr: [], // 获取市列表
      areaListArr: [], // 获取区列表
      unitOptions: [], // 单位列表
      titleOptions: [], // 职称列表
      courseOptions: [], // 学科列表
      levelOptions: [], // 学段列表
      tableData: [],
      is_adminOptions: isCheck(),
      is_teacherOptions: isCheck(),
      focus_project_id: "",
      dcConfig: {
        key: "",
        notify_url: "",
      }, //后台的key和notify_url接口地址
      unitForm: {
        page: 1,
        limit: 10,
        keywords: "",
      },
      total: 0,
      selectRow: {}, // 当前选中的行
      unitName: "", // 单位名称
      imageUrl: "",
      updateId: "", //
      class_id: "", //
      user_id: "", //
      title: "", //

      //   unitSearch: "",
      sexyOptions: [
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      rules: {
        // username: [
        //   { required: true, message: "请输入用户名", trigger: "blur" },
        // ],
        // address: [
        //   { required: true, message: "请输入联系地址", trigger: "blur" },
        // ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // repassword: [{ required: true, message: "确认密码", trigger: "blur" }],
        repassword: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "blur",
          },
          { validator: againValidatePass, trigger: "blur" },
        ],
        truename: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        idnum: [{ required: true, message: "请输入身份证", trigger: "blur" }],
        education: [],
        sexy: [{ required: true, message: "性别不能为空", trigger: "change" }],
        tel: [
          { required: true, message: "请输入手机", trigger: "blur" },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: "正确的手机号码",
            trigger: "blur",
          },
        ],
        // description: [{ required: true, message: '请输入个人简介', trigger: 'blur' }],
        unit: [{ required: true, validator: validateUnit, trigger: "blur" }],
        is_admin: [
          { required: true, message: "行政管理员不能为空", trigger: "change" },
        ],
        is_teacher: [
          { required: true, message: "班主任不能为空", trigger: "change" },
        ],
        province_id: [
          { required: true, message: "省份不能为空", trigger: "change" },
        ],
        city_id: [
          { required: true, message: "城市不能为空", trigger: "change" },
        ],
        area_id: [
          { required: true, message: "地区不能为空", trigger: "change" },
        ],
        // address: [
        //   { required: true, message: "联系地址不能为空", trigger: "blur" },
        // ],
      },
    };
  },
  methods: {
    // 选中
    onRadioChange(row) {
      this.tableData.map((e) => {
        // 取消全部的勾选
        this.$set(e, "radio", 0);
      });
      // 让当前行选中
      this.$set(row, "radio", 1);
      // 保存当前行
      this.selectRow = row;
    },
    // 修改查询的值
    changeVal(val) {
      this.unitForm.keywords = val.workName;
    },
    // 确定
    onCommitUnit() {
      this.$refs.unitRef.openDialog = false;
      this.unitName = this.selectRow.name;
      this.form.unit = this.selectRow.id;
      this.$refs["form"].validateField(["unit"]);
    },
    // 取消
    onCancelUnit() {
      this.$refs.unitRef.openDialog = false;
      if (!this.unitName) {
        // 修改时不用清空
        this.unitName = "";
        this.$set(this.form, "unit", "");
      }
    },
    onSearch() {
      this.unitForm.page = 1;
      this.onGetUnitList();
    },
    handleCurrentChange(val) {
      this.unitForm.page = val;
      this.onGetUnitList();
    },
    handleSizeChange(val) {
      this.unitForm.limit = val;
      this.onGetUnitList();
    },
    // 选择单位
    onSelectUnit() {
      this.$refs.unitRef.openDialog = true;
      // 单位列表
      this.onGetUnitList();
    },
    onClose() {
      this.$refs.unitRef.openDialog = false;
    },
    onGetUnitList() {
      GetOrganizetionList(this.unitForm).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.tableData.map((e) => {
          this.$set(e, "radio", 0);
        });
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // this.form.file = JSON.stringify(this.formFiles)

          let itemForm = { ...this.form };
          itemForm.image = this.imageUrl;
          //   itemForm.type = 3; // 1超级管理员 2项目管理员 3其他学员
          itemForm.class_id = this.class_id;
          itemForm.focus_project_id = this.focus_project_id;
          //   console.log(itemForm,'578');
          //   return;
          if (this.updateId) {
            itemForm.user_id = this.user_id;
            // 修改
            UpdateNewStudent(itemForm)
              .then((response) => {
                if (response.error_code === 201) {
                  this.messageTips("修改成功", "success");
                  this.openDialog = false;
                  this.$emit("requestCommonFn");
                }
              })
              .catch((reason) => {
                console.log(reason);
              });
          } else {
            // 添加
            AddNewStudent(itemForm)
              .then((response) => {
                if (response.error_code === 201) {
                  this.messageTips("新增成功", "success");
                  this.openDialog = false;
                  this.$emit("requestCommonFn");
                }
              })
              .catch((reason) => {
                console.log(reason);
              });
          }
        }
      });
    },
    // 取消按钮
    cancel() {
      this.unitName = "";
      this.$set(this.form, "unit", "");
      this.openDialog = false;
    },
    // 关闭dialog
    closeDialog() {
      // 重置表单
      this.resetForm("form");
      this.form = {};
      this.updateId = "";
      this.imageUrl = "";
    },
    // 根据学段获取学科列表
    handleCourseOptions(id) {
      this.form.subject = "";
      GetDataList({ type: 5, id: id }).then((response) => {
        this.courseOptions = response.data;
      });
    },
    // 根据省id获取市列表
    getCityList(val) {
      // 重置
      if (val !== "") {
        this.$set(this.form, "city_id", "");
        this.$set(this.form, "area_id", "");
        this.CityListApiFn(val);
        // 移除表单的验证规则
        this.$nextTick(() => {
          this.$refs["form"].clearValidate(["province_id"]);
        });
      }
    },
    // 获取省列表
    ProvinceListFn() {
      ProvinceListApi().then((res) => {
        this.provinceListArr = res.data;
      });
    },

    // 市列表
    CityListApiFn(val) {
      CityListApi(val).then((res) => {
        this.cityListArr = res.data;
      });
    },
    // 根据市id获取区列表
    getareaList(val) {
      // 重置
      if (val !== "") {
        this.$set(this.form, "area_id", "");
        this.AreaListApiFn(val);
        // 移除表单的验证规则
        this.$nextTick(() => {
          this.$refs["form"].clearValidate(["city_id"]);
        });
      }
    },
    // 区列表
    AreaListApiFn(val) {
      AreaListApi(val).then((res) => {
        this.areaListArr = res.data;
      });
    },
    // 区值变化
    changeArea(val) {
      if (val !== "") {
        this.$nextTick(() => {
          // 移除表单的验证规则
          this.$refs["form"].clearValidate(["area_id"]);
        });
      }
    },
    // 地址失焦时间
    inputBlurFn() {
      if (this.form.address !== "") {
        this.$nextTick(() => {
          // 移除表单的验证规则
          // this.$refs["form"].clearValidate(["address"]);
        });
      }
    },
    // 金山云上传成功的回调
    dcSuccess(data) {
      // this.loading = true;
      let eTag = data.upload.CompleteMultipartUploadResult.ETag;
      // 去掉字符串的双引号
      eTag = eTag.replace(/"/g, "");
      UPloadFileApi({ etag: eTag }).then((res) => {
        this.imageUrl = res.data.savepath;
        // this.form.resourseFile = res.data;
      });
    },
    // 获取key与回调url
    getKeyUrlFn() {
      GetKey_Url().then((res) => {
        this.getKey_UrlData = res.data;
        this.dcConfig.key = this.getKey_UrlData.key;
        this.dcConfig.notify_url = this.getKey_UrlData.notify_url;
        // 先请求到key和url再加载upload这个dom元素
        this.isOk = true;
      });
    },
    // 关闭dialog
    closeSubjectDialog() {
      // 重置表单
      this.resetForm("queryForm");
      // 清空表格数据
      //   this.subjectForm.option = [];
    },
    // 操作dialog
    operationDialog(
      educationOptions,
      unitOptions,
      titleOptions,
      levelOptions,
      class_id,
      updateId,
      user_id,
      title
    ) {
      this.openDialog = true;
      this.educationOptions = educationOptions;
      this.unitOptions = unitOptions;
      this.titleOptions = titleOptions;
      this.levelOptions = levelOptions;
      this.class_id = class_id;
      this.updateId = updateId;
      this.user_id = user_id;
      this.title = title;
      //   this.formType = formType;
      // 上传后去url接口
      this.getKeyUrlFn();
      // 市接口
      this.ProvinceListFn();
      // 获取项目id
      this.classInfoApiFn();
    },
    //获取班级信息
    classInfoApiFn() {
      ClassInfoApi({
        id: this.class_id,
      }).then((res) => {
        this.focus_project_id = res.data.class.focus_project_id;
      });
      if (this.updateId) {
        // 获取学员编辑信息
        StudentEditorInfo({ id: this.updateId }).then((res) => {
          this.imageUrl = res.data.image;
          this.$set(this.form, "username", res.data.username);
          this.$set(this.form, "truename", res.data.truename);
          this.$set(this.form, "idnum", res.data.idnum);
          this.$set(this.form, "education", this.filterValue(res.data.education));
          this.$set(this.form, "sexy", res.data.sexy);
          this.$set(this.form, "tel", res.data.tel);
          this.$set(this.form, "email", res.data.email);
          this.$set(this.form, "qq", res.data.qq);
          this.$set(this.form, "province_id", this.filterValue(res.data.province_id));
          // 省市区
          this.CityListApiFn(this.filterValue(res.data.province_id));
          this.$set(this.form, "city_id", this.filterValue(res.data.city_id));
          this.AreaListApiFn(this.filterValue(res.data.city_id));
          this.$set(this.form, "area_id", this.filterValue(res.data.area_id));

          this.$set(this.form, "address", res.data.address);
          this.$set(this.form, "description", res.data.description);
          this.$set(this.form, "unit", res.data.unit);
          this.unitName = res.data.unit_name;
          this.$set(this.form, "job", res.data.job);
          this.$set(this.form, "title", this.filterValue(res.data.title));
          this.$set(this.form, "level", this.filterValue(res.data.level));
          // 请求学科列表
          this.handleCourseOptions(res.data.level);
          this.$set(this.form, "subject", this.filterValue(res.data.subject));
          this.$set(this.form, "is_admin", res.data.is_admin);
          this.$set(this.form, "is_teacher", res.data.is_teacher);
          this.$set(this.form, "teacher_age", res.data.teacher_age);
          this.$set(this.form, "weixin", res.data.weixin);
          this.$set(this.form, "remark", res.data.remark);
        });
      }
    },
    //过滤0值
    filterValue(val) {
      return val ? val : "";
    },
    // 上传之前
    beforeAvatarUpload(file) {
      file = file[0];
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("文件大小超过 2MB");
      }
      let isAccept = new RegExp("image/*").test(file.type);
      console.log(isAccept);
      if (!isAccept) {
        this.$message.error("应该选择图片类型的文件");
      }
      return isRightSize && isAccept;
    },
    //手机号码变更回调
    telChange(val) {
      this.form.username = val;
    }
  },
};
</script>
 
<style lang = "less" scoped>
.add_new_student_dialog {
  .open-header {
    font-size: 18px;
    margin-bottom: 20px;
    margin-left: 15px;
    color: #303133;
  }
  /deep/ .el-form {
    .el-input {
      width: 198px !important;
    }
    .avatar_item {
      .dc-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .dc-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
      }

      .avatar-uploader-icon:hover {
        border-color: #409eff;
      }

      .avatar {
        width: 100px;
        height: 100px;
        display: block;
        border-radius: 6px;
      }
    }
    .train {
      margin-bottom: 0;
      .star {
        position: absolute;
        left: -92px;
        top: 0px;
        color: red;
      }
      .el-form-item__content {
        display: flex;
        position: relative;

        .el-input__inner {
          width: 150px;
        }
        .el-form-item {
          margin-right: 10px;
        }
        .address {
          .el-input__inner {
            /*width: 436px;*/
          }
        }
      }
    }
    .desc {
      .el-textarea__inner {
        width: 840px;
      }
    }
  }
}
</style>